import { render, staticRenderFns } from "./GiveRefundReason.vue?vue&type=template&id=52df9865&scoped=true&"
import script from "./GiveRefundReason.vue?vue&type=script&lang=js&"
export * from "./GiveRefundReason.vue?vue&type=script&lang=js&"
import style0 from "./GiveRefundReason.vue?vue&type=style&index=0&id=52df9865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df9865",
  null
  
)

export default component.exports